import React from "react";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white mt-10 p-5 text-center">
      <p className="font-semibold">© 2025 www.meruram.in. All Rights Reserved.</p>
      <p className="text-sm mt-1">Office No. 43, 4th Floor, K.K. Market, S. No. 19A/3B, Dhankawadi, Pune – 411043, Maharashtra, India. </p>
    </footer>
  );
}
